import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";

const EditPost = (props) => {
  return (
    <Modal
      className="Editpost-modal"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="edit-post-body">
          <div className="modal-image">
            <img src={props.image} alt="published post image" />
          </div>

          <h3>
            {props.status !== "draft" ? (
              <>
                <>
                  {moment(props.published_at).unix() < moment().unix()
                    ? "Published on "
                    : "Scheduled on "}
                  {moment(props.published_at).format("MMMM Do YYYY, h:mm a")}
                </>
              </>
            ) : (
              "Draft"
            )}
          </h3>
          <p dangerouslySetInnerHTML={{ __html: props.content ?? "" }}></p>
          <div className="post-tag">
            {/* <div className="post-tag-row">
              <div className="icon">
                <img src={Like} alt="like icon" />
              </div>
              <p>0 likes</p>
            </div> */}
          </div>
          <div className="editpost-btn-row">
            <button onClick={props.onHide} className="cancel-btn">
              Cancel
            </button>
            {moment(props.published_at).unix() < moment().unix() === false ? (
              <Link to={`/edit-post/${props.id}`} className="button">
                Edit Post
              </Link>
            ) : (
              <button onClick={props.delete} className="button">
                Delete Post
              </button>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditPost;
